
import { Vue, Options } from "vue-class-component";
import Timeline from "./detail-history/cargo-v2-detail-history-timeline.vue";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import formatDateBasedTimezoneValue from "@/app/infrastructures/misc/common-library/FormatDateBasedTimezoneValue";
import { CargoV2HistoryItem } from "@/domain/entities/CargoV2";

@Options({
  components: {
    Timeline,
  },
})

export default class CargoV2DetailHistory extends Vue {
  activeMenu = 0;
  get tabHistory() {
    return [
      {
        title: this.$t("cargoV2.components.detailHistory.title"),
        value: 0,
      },
    ];
  }

  get historyData() {
    return CargoV2Controller.cargoHistory;
  }

  get historyId() {
    return this.getHistoryId();
  }

  getHistoryId() {
    const url = this.$route.path;
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 2];
  }

  formatDate(dateTime: string) {
    return formatDateBasedTimezoneValue(dateTime, "DD MMM YYYY", true);
  }

  flightDateTime(historyItem: CargoV2HistoryItem) {
    const arrivalStatus = ["Flight Arrived", "Shipment Flight Partially Arrived"]
    return arrivalStatus.includes(historyItem.status) ? historyItem.arrivalDateTime : historyItem.flightDateTime
  }

  // load history data
  async loadHistoryData() {
    MainAppController.setLoadingModal(true);
    await this.fetchCargoV2HistoryData();
  }

  async fetchCargoV2HistoryData() {
    // get the id from second to last url
    const response = await CargoV2Controller.getCargoHistory(this.historyId)
      .finally(() => {
      MainAppController.setLoadingModal(false);
    });
    console.log(response);
  }

  mounted() {
    this.loadHistoryData();
  }
}
